/* Custom Product Builder - barra sticky, auto-avanzamento step, freccia scroll
   Paolina Roma (Dawn). Riscrittura di assets/cpbnew.js (739 righe).

   Cosa cambia rispetto al Motion:
   - La barra viene creata SOLO dopo il mount reale dell'app (evento
     CPB_ON_PRODUCT_MOUNTED, con un MutationObserver su #product-builder come
     unico fallback): niente piu' setTimeout a 500/1000/1500/2000/3000ms, e
     niente barra fantasma con "Total: EUR 25.00" se l'app non parte.
   - Il prezzo iniziale non e' piu' hardcoded: parte vuoto e lo riempie il sync.
   - Via la macchina dei charm nella barra (era invisibile in produzione):
     restano prezzo, spacer e CTA. Con lei sono spariti il
     setInterval(1000) perenne e un MutationObserver sulle classi.
   - Il fallback `form[action*="/cart/add"].submit()` e' stato tolto: in Dawn
     avrebbe trovato il form di main-product e messo a carrello il prodotto
     base senza configurazione.
   - La freccia di scroll usa event delegation invece di un MutationObserver
     che ri-agganciava i listener a ogni mutazione.
   - Zero console.log, zero jQuery. */

(function () {
  'use strict';

  var MOUNT_EVENT = 'CPB_ON_PRODUCT_MOUNTED';
  var READY_SELECTOR = '.cpb-option, .cpb-category, .cpb-root';

  var CART_ICON =
    '<svg class="cpb-sticky-cart-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
    '<path d="M9 22C9.55228 22 10 21.5523 10 21C10 20.4477 9.55228 20 9 20C8.44772 20 8 20.4477 8 21C8 21.5523 8.44772 22 9 22Z" fill="currentColor"/>' +
    '<path d="M20 22C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22Z" fill="currentColor"/>' +
    '<path d="M1 1H5L7.68 14.39C7.77144 14.8504 8.02191 15.264 8.38755 15.5583C8.75318 15.8526 9.2107 16.009 9.68 16H19.4C19.8693 16.009 20.3268 15.8526 20.6925 15.5583C21.0581 15.264 21.3086 14.8504 21.4 14.39L23 6H6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  var LABEL_IDLE = '<span>ADD TO CART</span>';
  var LABEL_BUSY = '<span>ADDING...</span>';
  var LABEL_DONE = '<span>ADDED!</span>';

  var builder = document.getElementById('product-builder');
  if (!builder) return;

  /* ==========================================================
     Mount dell'app: un solo punto di verita' per tutti i moduli
     ========================================================== */
  var mounted = false;
  var callbacks = [];
  var mountObserver = null;

  function markMounted() {
    if (mounted) return;
    mounted = true;
    if (mountObserver) {
      mountObserver.disconnect();
      mountObserver = null;
    }
    document.body.removeEventListener(MOUNT_EVENT, markMounted);
    callbacks.forEach(function (fn) {
      fn();
    });
    callbacks = [];
  }

  function whenMounted(fn) {
    if (mounted) {
      fn();
      return;
    }
    callbacks.push(fn);
  }

  document.body.addEventListener(MOUNT_EVENT, markMounted);

  if (builder.querySelector(READY_SELECTOR)) {
    markMounted();
  } else {
    mountObserver = new MutationObserver(function () {
      if (builder.querySelector(READY_SELECTOR)) markMounted();
    });
    mountObserver.observe(builder, { childList: true, subtree: true });
  }

  /* ==========================================================
     1. Barra sticky
     ========================================================== */
  var PRICE_SOURCES = [
    '.cpb-product-price',
    '.cpb-product-full-price [data-testid="multycurrency-price"]',
    '[class*="product-price"]',
    '.price'
  ];

  /* L'app di conversione valuta concatena il prezzo in euro con quello nella
     valuta del visitatore (es. "19,00" in euro subito seguito da "$19.00"):
     se compare un simbolo di un'altra valuta si tiene solo quella locale.
     Simboli scritti con escape unicode per non dipendere dall'encoding. */
  function normalizePrice(text) {
    var price = text.trim();
    var hasOtherCurrency = /[$\u00A3\u00A5\u20B9\u20BD\u20A9\u20BA]|\bkr\b|\bz\u0142\b/i.test(price);
    if (hasOtherCurrency && price.indexOf('\u20AC') !== -1) {
      price = price.replace(/\u20AC[\s\d.,]*/g, '').trim();
    }
    return price;
  }

  function buildBar() {
    var existing = document.querySelector('.cpb-sticky-bar');
    if (existing) existing.remove();

    var bar = document.createElement('div');
    bar.className = 'cpb-sticky-bar';
    bar.innerHTML =
      '<div class="cpb-sticky-bar-inner">' +
      '<div class="cpb-sticky-price">' +
      '<span class="cpb-sticky-price-label">Total:</span>' +
      '<span class="cpb-sticky-price-value" aria-live="polite"></span>' +
      '</div>' +
      '<div class="cpb-sticky-bar__spacer" aria-hidden="true"></div>' +
      '<div class="cpb-sticky-cta">' +
      '<button type="button">' +
      CART_ICON +
      LABEL_IDLE +
      '</button>' +
      '</div>' +
      '</div>';

    document.body.appendChild(bar);
    document.body.classList.add('has-cpb-sticky');

    bar.querySelector('.cpb-sticky-cta button').addEventListener('click', handleAddToCart);
    startPriceSync(bar.querySelector('.cpb-sticky-price-value'));
  }

  function startPriceSync(target) {
    var pending = false;

    function readPrice() {
      for (var i = 0; i < PRICE_SOURCES.length; i++) {
        var el = builder.querySelector(PRICE_SOURCES[i]);
        if (el) return el.textContent;
      }
      return null;
    }

    function update() {
      pending = false;
      var raw = readPrice();
      if (raw === null) return;
      var price = normalizePrice(raw);
      if (price && target.textContent !== price) target.textContent = price;
    }

    function schedule() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(update);
    }

    update();

    var source =
      builder.querySelector('.cpb-product-full-price, .cpb-product-price, [class*="price-container"]') || builder;

    new MutationObserver(schedule).observe(source, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function restoreButton(button) {
    button.innerHTML = CART_ICON + LABEL_IDLE;
    button.removeAttribute('aria-busy');
  }

  function handleAddToCart(event) {
    event.preventDefault();

    var button = event.currentTarget;
    if (button.getAttribute('aria-busy') === 'true') return;

    var original = builder.querySelector(
      '.cpb-add-to-cart-button, button[class*="add-to-cart"], [data-add-to-cart]'
    );

    /* Nessun bottone dell'app: meglio non fare nulla che inviare il form
       di main-product, che aggiungerebbe il prodotto senza configurazione. */
    if (!original) return;

    button.setAttribute('aria-busy', 'true');
    button.innerHTML = LABEL_BUSY;

    original.click();

    /* L'app non espone un evento di "aggiunto": si resta sul doppio timer
       del Motion (3s di generazione immagine + 3s di conferma a schermo). */
    setTimeout(function () {
      button.innerHTML = LABEL_DONE;
      setTimeout(function () {
        restoreButton(button);
      }, 3000);
    }, 3000);
  }

  whenMounted(buildBar);

  /* ==========================================================
     2. Auto-avanzamento degli step
     Quando aumentano i charm attivi, riscrive cpb-current-tab-index-N sulla
     classe di .cpb-panels-container. skipFirstOptions = 2 sono le opzioni
     non-charm del primo pannello (metallo + catena): il numero cambia se il
     configuratore viene riorganizzato nell'admin CPB.
     ========================================================== */
  var STEP_PREFIX = 'cpb-current-tab-index-';
  var SKIP_FIRST_OPTIONS = 2;
  var ADVANCE_DELAY = 150;
  var LOCK_DELAY = 300;

  var stepLocked = false;
  var lastCharmCount = 0;
  var maxSteps = null;
  var advanceTimer = null;

  function panelsContainer() {
    return builder.querySelector('.cpb-panels-container');
  }

  function countCharms() {
    var active = builder.querySelectorAll('.cpb-option.cpb-active').length;
    return Math.max(0, active - SKIP_FIRST_OPTIONS);
  }

  function currentStep(container) {
    var match = container.className.match(/cpb-current-tab-index-(\d+)/);
    return match ? parseInt(match[1], 10) : 0;
  }

  function readMaxSteps() {
    var panels = builder.querySelectorAll('.cpb-panel-wrapper');
    if (panels.length > 0) maxSteps = panels.length - 1;
    return maxSteps;
  }

  function targetStep(charmCount) {
    if (charmCount === 0) return 1;
    if (!maxSteps) readMaxSteps();
    var target = charmCount + 1;
    if (maxSteps && target > maxSteps) target = maxSteps;
    return target;
  }

  function setStep(container, index) {
    Array.prototype.slice.call(container.classList).forEach(function (name) {
      if (name.indexOf(STEP_PREFIX) === 0) container.classList.remove(name);
    });
    container.classList.add(STEP_PREFIX + index);
  }

  function advance() {
    var container = panelsContainer();
    if (!container || stepLocked) return;

    var charmCount = countCharms();
    if (charmCount <= lastCharmCount) {
      lastCharmCount = charmCount;
      return;
    }
    lastCharmCount = charmCount;

    /* targetStep rinfresca maxSteps se i pannelli sono arrivati dopo. */
    var next = targetStep(charmCount);
    var current = currentStep(container);
    if (maxSteps && current >= maxSteps) return;
    if (next === current) return;

    stepLocked = true;
    setStep(container, next);
    setTimeout(function () {
      stepLocked = false;
    }, LOCK_DELAY);
  }

  function initAutoStep() {
    readMaxSteps();
    lastCharmCount = countCharms();

    new MutationObserver(function (mutations) {
      if (stepLocked) return;
      for (var i = 0; i < mutations.length; i++) {
        var target = mutations[i].target;
        if (!target.classList || !target.classList.contains('cpb-option')) continue;
        if (!target.classList.contains('cpb-active')) continue;
        clearTimeout(advanceTimer);
        advanceTimer = setTimeout(advance, ADVANCE_DELAY);
        return;
      }
    }).observe(builder, { attributes: true, attributeFilter: ['class'], subtree: true });
  }

  whenMounted(initAutoStep);

  /* ==========================================================
     3. Freccia "scorri" sui charm (mobile)
     Gli eventi scroll non fanno bubbling ma si intercettano in cattura.
     ========================================================== */
  document.addEventListener(
    'scroll',
    function (event) {
      var el = event.target;
      if (!el || !el.classList || !el.classList.contains('cpb-category-options-container')) return;
      if (!el.classList.contains('img') || el.classList.contains('pr-scrolled')) return;
      if (el.scrollLeft > 10) el.classList.add('pr-scrolled');
    },
    { capture: true, passive: true }
  );
})();
